import React, { useEffect, useMemo, useState } from "react";
import { Table, Typography } from "antd";
import ConsolidatedReportsTable from "../../../components/ConsolidatedReportsTable/ConsolidatedReportsTable";
import { fetchOtherProjectDataFilledStatus } from "../../../redux/projectsSlice/projectSlice";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../../../components/Common/SearchBar/SearchBar";
import Breadcrumb from "../../../components/BreadCrumb/BreadCrumb";
import CustomSelectWithFilter from "../../../components/Common/CustomSelect/CustomSelectWithFilter";
import { getAllUnits } from "../../../redux/unitSlice/unitSlice";
import CustomPagination from "../../../components/Common/CustomPagination/CustomPagination";
const yn = (status) =>
    status === "FILLED" ? "Y" : "P";

/* -------------------------
 METRICS ROWS
------------------------- */

const METRICS = [
    {
    label: "Material Cost (DM)",
    field: "PROJECT_COST_DM_STATUS",
  },

  {
    label: "Conversion Cost (C)",
    field: "PROJECT_COST_C_STATUS",
  },
  
  {
    label: "Apportioned Cost",
    field: "APORTIONED_COST_STATUS",
  },

  {
    label: "Operational Income",
    field: "OPERATIONAL_INCOME_STATUS",
  },

  {
    label: "Gross Billing",
    field: "GROSS_BILLING_STATUS",
  },

  {
    label: "Net Billing",
    field: "NET_BILLING_STATUS",
  },

  {
    label: "Cash Inflow",
    field: "CASH_INFLOW_STATUS",
  },

  {
    label: "Cash Outflow",
    field: "CASH_OUTFLOW_STATUS",
  },

  

];

/* -------------------------
 BUILD TABLE DATA
------------------------- */

function buildMonitoringData(apiData) {

    if (!apiData?.length) return {
        columns: [],
        rows: []
    };


    /// ✅ Dynamic Unit Columns
    const unitColumns = [

        ...new Set(

            apiData.map(
                item => item.MNF_UNIT_NAME
            )

        )

    ].sort();


    /// GROUP PROJECTS
    const grouped = {};

    apiData.forEach(row => {

        if (!grouped[row.PROJECT_TITLE]) {

            grouped[row.PROJECT_TITLE] = [];

        }

        grouped[row.PROJECT_TITLE].push(row);

    });


    const rows = [];

    Object.entries(grouped)

        .forEach(([projectName, projectRows]) => {

            METRICS.forEach(

                (metric, index) => {

                    const unitCells = {};

                    /// blank default
                    unitColumns.forEach(

                        u => unitCells[u] = "-"

                    );


                    /// fill Y/N
                    projectRows.forEach(r => {

                        unitCells[r.MNF_UNIT_NAME]
                            =
                            yn(r[metric.field]);

                    });


                    rows.push({

                        key:
                            `${projectName}_${metric.label}`,

                        projectName,

                        particulars:
                            metric.label,

                        rowSpan:
                            index === 0
                                ? METRICS.length
                                : 0,

                        ...unitCells

                    });

                });

        });


    /// COLUMNS
    const columns = [

        {

            title: "Project Name",

            dataIndex: "projectName",

            width: 220,
            fixed: "left",

            onCell: (record) => ({

                rowSpan: record.rowSpan,

                style: {
                    fontWeight: 600,
                    verticalAlign: "middle",
                    textAlign: "center"
                }
            })

        },

        {

            title: "Parameters",

            dataIndex: "particulars",
            fixed: "left",

            width: 220,

            onCell: () => ({

                style: {
                    background: "#fafafa"
                }

            })

        },

        ...unitColumns.map(unit => ({

            title: unit,

            dataIndex: unit,

            align: "center",

            width: 100,

           render: (value) => {
  if (!value || value === "-") return "-";

  const isFilled = value === "Y";

  return (
    <span
      style={{
        color: isFilled ? "#16a34a" : "#dc2626", // green / red
        fontWeight: 600,
      }}
    >
      {value}
    </span>
  );
}

        }))

    ];

    return {

        columns,
        rows

    };

}

/* -------------------------
 COMPONENT
------------------------- */

export default function OtherProjectStatusTable() {
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize=1000000;
    
    const [selectedUnitRegion,setSelectedUnitRegion]=useState("Select Unit/Region")
            const { otherProjectStatus,loading,totalOtherProjectData } = useSelector((state) => state.project);
  const {  allUnitsList } =
    useSelector((state) => state.unit);
        const dispatch = useDispatch();
        useEffect(() => {
            dispatch(getAllUnits());
          }, [dispatch]);
useEffect(() => {
    if(selectedUnitRegion==="Select Unit/Region"){
                        // dispatch(fetchProjectDataSubmissions({ page: currentPage, limit: 10, search: search }));
                        dispatch(fetchOtherProjectDataFilledStatus({search: searchValue,page:currentPage,limit:pageSize}));
                        return;
                }else{      
               
                                dispatch(fetchOtherProjectDataFilledStatus({search: searchValue,MNF_UNIT:selectedUnitRegion,page:currentPage,limit:pageSize}));
                }
        }, [ searchValue,selectedUnitRegion,currentPage,dispatch]);
    const {

        columns,
        rows

    } = useMemo(

        () => buildMonitoringData(otherProjectStatus),

        [otherProjectStatus]

    );

    return (

        <div className="p-5" >
{/* 
            <Title level={5}>

                Monitoring projects submission status

            </Title> */}
           <div className="">
                        <Breadcrumb />
                        <div className="pt-[20px] flex justify-between">
                                <div className="flex gap-3">
                                        <div>
                                                <div className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0%] text-[#101828]">Data Submission Status</div>
                                        </div>
                                </div>
                        </div>

                        <div className="mt-[22px] flex justify-between">
                                <SearchBar
                                        placeholder="Search by Project name"
                                        onSearch={(value) => setSearchValue(value)}
                                />{' '}
                                <div className="flex gap-[12px]">
                                         <div className="flex gap-[12px]">
                                        <CustomSelectWithFilter
                                                showSearch="true"
                                                data={
                                                        Array.isArray(allUnitsList)
                                                                ? allUnitsList.map((value) => ({
                                                                          label: value?.UNIT_DISPLAY_NAME,
                                                                          value: value?.MNF_UNIT,
                                                                  }))
                                                                : []
                                                }
                                                onChange={(value) => {
                                                       setSelectedUnitRegion(value)
                                                }}
                                                value={selectedUnitRegion}
                                                placeholder="Select Unit/Region"
                                                className="w-[15rem]"
                                        />
                                        {/* <CustomSelect
                                                placeholder="All Time"
                                                options={[
                                                        {
                                                                value: 'not_initiated',
                                                                label: 'Not Initiated',
                                                        },
                                                        {
                                                                value: 'incomplete',
                                                                label: 'Incomplete',
                                                        },
                                                        {
                                                                value: 'pending',
                                                                label: 'Pending for Final Submission',
                                                        },
                                                        { value: 'submitted', label: 'Submitted' },
                                                ]}
                                        /> */}
                                        {/* <Button
                                                text="Export report"
                                                icon={DownloadIcon}
                                        /> */}
                                </div>                               </div>
                        </div>

                        {/* <div className="py-[32px]">
                                <DataSubmissionStatusTable
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                />
                        </div> */}
                       
                </div>

           <div className="mt-4">
             <ConsolidatedReportsTable

                bordered

                size="small"

                pagination={false}

                rowKey="key"

                columns={columns}

                dataSource={rows}
                loading={loading}

                sticky
    scroll={{ 
        x: 'max-content',
        y: 600   // 👈 required for sticky header
    }}

            />

            <CustomPagination
               totalItems={totalOtherProjectData}
                                                pageSize={pageSize}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
            />
           </div>

        </div>

    );

}